module.exports = __webpack_public_path__ + "static/img/3-info-b5.16874d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b5.jpg
// module id = mCE0
// module chunks = 0